/**
 * Custom theme context
 * Extends MUI Theme context to support theme switching
 */

import { createContext, useMemo, useState, useContext } from "react";

import {
  useTheme as muiUseTheme,
  ThemeProvider as MuiThemeProvider,
} from "@mui/material/styles";

import { createPreimageTheme } from "utils/theme";

const ThemeContext = createContext({ toggleColorMode: () => {} });

interface ThemeProviderProps {
  children: React.ReactNode;
}

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  const [mode, setMode] = useState<"light" | "dark">("dark");

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const theme = useMemo(() => createPreimageTheme(mode), [mode]);

  return (
    <ThemeContext.Provider value={colorMode}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

const useTheme = () => ({
  ...useContext(ThemeContext),
  ...muiUseTheme(),
});

export { ThemeProvider, useTheme };
